const DateFormatter = (date: string): Date => {
  return new Date(date?.replace(/-/g, '/'))
}

export default DateFormatter
